import _ from "../../../shared/utils/lodash";
var placeTypes = {
    city: "city",
    continent: "continent",
    country: "country",
    neighborhood: "neighborhood",
    region: "region",
};
/**
 * Uses the placeTypes to generate several isPlaceType functions.
 *
 * isCountry(place);
 * isContinent(place);
 * isRegion(place);
 */
var placeTypeUtils = Object.keys(placeTypes).reduce(function (m, pt) {
    var memo = m;
    var key = "" + _.capitalize(pt);
    memo["is" + key] = function (p) { return p.placeType === placeTypes[pt]; };
    return memo;
}, {});
export default placeTypeUtils;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/placeTypeUtils.ts
// module id = CEdI
// module chunks = 2